webpackJsonp([174759553322802],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
	        size = props.size,
	        className = props.className,
	        others = __rest(props, ["prefixCls", "size", "className"]);
	    // large => lg
	    // small => sm
	
	
	    var sizeCls = '';
	    switch (size) {
	        case 'large':
	            sizeCls = 'lg';
	            break;
	        case 'small':
	            sizeCls = 'sm';
	        default:
	            break;
	    }
	    var classes = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + sizeCls, sizeCls), className);
	    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classes }));
	};
	exports['default'] = ButtonGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(15);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(13);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(12);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(41);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _icon = __webpack_require__(21);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	function isString(str) {
	    return typeof str === 'string';
	}
	// Insert one space between two chinese characters automatically.
	function insertSpace(child, needInserted) {
	    // Check the child if is undefined or null.
	    if (child == null) {
	        return;
	    }
	    var SPACE = needInserted ? ' ' : '';
	    // strictNullChecks oops.
	    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	        return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
	    }
	    if (typeof child === 'string') {
	        if (isTwoCNChar(child)) {
	            child = child.split('').join(SPACE);
	        }
	        return React.createElement(
	            'span',
	            null,
	            child
	        );
	    }
	    return child;
	}
	
	var Button = function (_React$Component) {
	    (0, _inherits3['default'])(Button, _React$Component);
	
	    function Button(props) {
	        (0, _classCallCheck3['default'])(this, Button);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	        _this.handleClick = function (e) {
	            // Add click effect
	            _this.setState({ clicked: true });
	            clearTimeout(_this.timeout);
	            _this.timeout = window.setTimeout(function () {
	                return _this.setState({ clicked: false });
	            }, 500);
	            var onClick = _this.props.onClick;
	            if (onClick) {
	                onClick(e);
	            }
	        };
	        _this.state = {
	            loading: props.loading,
	            clicked: false,
	            hasTwoCNChar: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Button, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fixTwoCNChar();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var currentLoading = this.props.loading;
	            var loading = nextProps.loading;
	            if (currentLoading) {
	                clearTimeout(this.delayTimeout);
	            }
	            if (typeof loading !== 'boolean' && loading && loading.delay) {
	                this.delayTimeout = window.setTimeout(function () {
	                    return _this2.setState({ loading: loading });
	                }, loading.delay);
	            } else {
	                this.setState({ loading: loading });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.fixTwoCNChar();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeout) {
	                clearTimeout(this.timeout);
	            }
	            if (this.delayTimeout) {
	                clearTimeout(this.delayTimeout);
	            }
	        }
	    }, {
	        key: 'fixTwoCNChar',
	        value: function fixTwoCNChar() {
	            // Fix for HOC usage like <FormatMessage />
	            var node = (0, _reactDom.findDOMNode)(this);
	            var buttonText = node.textContent || node.innerText;
	            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	                if (!this.state.hasTwoCNChar) {
	                    this.setState({
	                        hasTwoCNChar: true
	                    });
	                }
	            } else if (this.state.hasTwoCNChar) {
	                this.setState({
	                    hasTwoCNChar: false
	                });
	            }
	        }
	    }, {
	        key: 'isNeedInserted',
	        value: function isNeedInserted() {
	            var _props = this.props,
	                loading = _props.loading,
	                icon = _props.icon,
	                children = _props.children;
	
	            var iconType = loading ? 'loading' : icon;
	            return React.Children.count(children) === 1 && (!iconType || iconType === 'loading');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this3 = this;
	
	            var _a = this.props,
	                type = _a.type,
	                shape = _a.shape,
	                size = _a.size,
	                className = _a.className,
	                htmlType = _a.htmlType,
	                children = _a.children,
	                icon = _a.icon,
	                prefixCls = _a.prefixCls,
	                ghost = _a.ghost,
	                others = __rest(_a, ["type", "shape", "size", "className", "htmlType", "children", "icon", "prefixCls", "ghost"]);var _state = this.state,
	                loading = _state.loading,
	                clicked = _state.clicked,
	                hasTwoCNChar = _state.hasTwoCNChar;
	            // large => lg
	            // small => sm
	
	            var sizeCls = '';
	            switch (size) {
	                case 'large':
	                    sizeCls = 'lg';
	                    break;
	                case 'small':
	                    sizeCls = 'sm';
	                default:
	                    break;
	            }
	            var ComponentProp = others.href ? 'a' : 'button';
	            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-clicked', clicked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), _classNames));
	            var iconType = loading ? 'loading' : icon;
	            var iconNode = iconType ? React.createElement(_icon2['default'], { type: iconType }) : null;
	            var kids = children || children === 0 ? React.Children.map(children, function (child) {
	                return insertSpace(child, _this3.isNeedInserted());
	            }) : null;
	            return React.createElement(
	                ComponentProp,
	                (0, _extends3['default'])({}, (0, _omit2['default'])(others, ['loading']), { type: others.href ? undefined : htmlType || 'button', className: classes, onClick: this.handleClick }),
	                iconNode,
	                kids
	            );
	        }
	    }]);
	    return Button;
	}(React.Component);
	
	exports['default'] = Button;
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	    prefixCls: 'ant-btn',
	    loading: false,
	    ghost: false
	};
	Button.propTypes = {
	    type: _propTypes2['default'].string,
	    shape: _propTypes2['default'].oneOf(['circle', 'circle-outline']),
	    size: _propTypes2['default'].oneOf(['large', 'default', 'small']),
	    htmlType: _propTypes2['default'].oneOf(['submit', 'button', 'reset']),
	    onClick: _propTypes2['default'].func,
	    loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	    className: _propTypes2['default'].string,
	    icon: _propTypes2['default'].string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(71);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _buttonGroup = __webpack_require__(70);
	
	var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_button2['default'].Group = _buttonGroup2['default'];
	exports['default'] = _button2['default'];
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(17);
	
	__webpack_require__(86);

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	
	  'upcoming-tutorials-articles-and-tutorial-requests': {
	    type: 'normal',
	    title: 'Upcoming Tutorials, Articles and Tutorial Requests',
	    data: [{ title: 'General', url: '/upcoming-tutorials-articles-and-tutorial-requests' }, { title: 'Under Consideration', url: '/upcoming-tutorials-articles-and-tutorial-requests/under-consideration' }]
	  },
	
	  'user-authentication-using-aws-cognito': {
	    type: 'normal',
	    title: 'User Authentication Using AWS Cognito',
	    data: [{ title: 'Getting Started', url: '/user-authentication-using-aws-cognito/getting-started' }, { title: 'Setting Up The Frontend', url: '/user-authentication-using-aws-cognito/setting-up-the-frontend' }]
	  },
	
	  'building-a-todo-application-using-graphql-and-aws-appsync': {
	    type: 'sections',
	    title: 'Building a Todo Application using GraphQL and AWS AppSync',
	    data: [{
	      title: 'Backend',
	      data: [{ title: 'Introduction', url: '/building-a-todo-application-using-graphql-and-aws-appsync' }, { title: 'Designing Our Schema', url: '/building-a-todo-application-using-graphql-and-aws-appsync/designing-schema' }, { title: 'Attaching Resolver', url: '/building-a-todo-application-using-graphql-and-aws-appsync/attaching-resolver' }, { title: 'Attaching Update and Delete Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/attaching-update-and-delete-resolvers' }, { title: 'Creating Resources and Attaching Remaining Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/creating-additional-resources-and-attaching-remaining-resolvers' }, { title: 'Advanced Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/advanced-resolvers' }]
	    }, {
	      title: 'Frontend',
	      data: [{ title: 'Getting Started With The Frontend', url: '/building-a-todo-application-using-graphql-and-aws-appsync/getting-started-with-the-frontend' }, { title: 'The CRUD Operations', url: '/building-a-todo-application-using-graphql-and-aws-appsync/the-crud-operations' }]
	    }]
	  }
	
	  /*
	    'hello-world': {
	      type: 'normal',
	      data: [
	        { title: 'Hello', url: '/hello', },
	        { title: 'World', url: '/world', },
	      ],
	    },
	  
	  */
	
	};
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var articles = [{
	  title: 'Progressive Web Application Using React - Part Three',
	  url: 'https://v1.dhruvkumarjha.com/articles/progressive-web-application-using-react-part-three',
	  date: '1st June 2017 at 07:15 PM',
	  excerpt: 'In this tutorial we will allow users to add the subreddits they are interested in, Save it in local database and cache the API response. We will also make use of Web App Manifest and Service Workers.'
	}, {
	  title: 'Progressive Web Application Using React - Part Two',
	  url: 'https://v1.dhruvkumarjha.com/articles/progressive-web-application-using-react-part-two',
	  date: '29th May 2017 at 06:50 PM',
	  excerpt: 'In this tutorial we will build our User Interface using the Material UI framework and setup webpack and react router as well.'
	}, {
	  title: 'Progressive Web Application Using React - Part One',
	  url: 'https://v1.dhruvkumarjha.com/articles/progressive-web-application-using-react-part-one',
	  date: '28th May 2017 at 03:10 PM',
	  excerpt: 'In this tutorial series we will learn to build a progressive web app (PWA) using React JS, Redux, Webpack and few other packages. We will be using Material UI Framework for our User Interface and Firebase for hosting our application.'
	}, {
	  title: 'Building a Static Website Using React JS: Part #3 Adding Meta Tags and Generating HTML Pages',
	  url: 'https://v1.dhruvkumarjha.com/articles/building-a-static-website-using-react-js-part-3-adding-meta-tags-and-generating-html-pages',
	  date: '4th May 2017 at 07:30 PM',
	  excerpt: 'In this Tutorial we will add Meta Tags to our website, Optimizing it for Search Engines and Social Sharing. We will also generate HTML pages for all the routes in our website so it loads faster and can be indexed and viewed by Crawlers. And we can host it wherever we want without needing a server while still getting the server side rendering (pre-rendering).'
	}, {
	  title: 'Building a Static Website Using React JS: Part #2 Creating and Hosting the Website',
	  url: 'https://v1.dhruvkumarjha.com/articles/building-a-static-website-using-react-js-part-2-creating-and-hosting-the-website',
	  date: '30th April 2017 at 07:20 PM',
	  excerpt: 'In this tutorial we will be creating our website along with all the pages and seo meta tags and then hosting it online. You can host it wherever you want, I have decided to host it on Firebase.'
	}, {
	  title: 'Building a Static Website Using React JS: Part #1 Project Setup and Website UI',
	  url: 'https://v1.dhruvkumarjha.com/articles/building-a-static-website-using-react-js-part-1-project-setup-and-website-ui',
	  date: '29th April 2017 at 05:10 PM',
	  excerpt: 'In this tutorial series we will learn to build a static website using React JS, Complete with Search Engine Optimization, Code Splitting, Pre-rendering and gzipping. We will also handle form Submission using a Serverless API and later publish our website.'
	}, {
	  title: 'Introduction To Creating React Components And Publishing Them To NPM',
	  url: 'https://v1.dhruvkumarjha.com/articles/introduction-to-creating-react-components-and-publishing-them-to-npm',
	  date: '25th April 2017 at 04:20 AM',
	  excerpt: 'In this tutorial we will create a simple react component and later we will publish it to the npm. After publishing we will use that compoent in our other projects.'
	}, {
	  title: 'Best Resources For Learning React JS and Javascript',
	  url: 'https://v1.dhruvkumarjha.com/articles/best-resources-for-learning-react-js-and-javascript',
	  date: '23rd April 2017 at 05:45 PM',
	  excerpt: 'Let\'s checkout some of the best resources available for us to learn react js and javascript. These resources helps us understand new concepts, application architectures and frontend application development in general.'
	}, {
	  title: 'Build a Notification Service Using AWS CodeStar, Node and Lambda',
	  url: 'https://v1.dhruvkumarjha.com/articles/build-a-notification-service-using-aws-codestar-node-and-lambda',
	  date: '20th April 2017 at 07:20 PM',
	  excerpt: 'In this tutorial we will be using AWS services and create a service that will allow us to send Email and SMS notifications wherever we want by calling an API endpoint. We will make use of AWS CodeStar, Lambda, Simple Email Service (SES), Simple Notification Service (SNS) and few other..., Let\'s get started.'
	}, {
	  title: 'GraphQL For Beginners: Part #2 Hello Real World',
	  url: 'https://v1.dhruvkumarjha.com/articles/graphql-for-beginners-part-2-hello-real-world',
	  date: '19th April 2017 at 06:40 PM',
	  excerpt: 'In this tutorial let\'s setup our application, install all the dependencies and write our first Real hello world application. We will write our very first graphql Type, Query, Mutation, Resolve and Sehema methods.'
	}, {
	  title: 'GraphQL For Beginners: Part #1 The Terminology',
	  url: 'https://v1.dhruvkumarjha.com/articles/graphql-for-beginners-part-1-the-terminology',
	  date: '18th April 2017 at 04:30 PM',
	  excerpt: 'In this tutorial series we will get started with GraphQL and build an application using GraphQL, Node, Express and MongoDB. However in this Article, Let\'s get the GraphQL terminology down.'
	}, {
	  title: 'Top Ten UI Libraries For Developing React JS Applications',
	  url: 'https://v1.dhruvkumarjha.com/articles/top-ten-ui-libraries-for-developing-react-js-applications',
	  date: '17th April 2017 at 04:00 PM',
	  excerpt: 'Let\'s checkout the Top ten Best UI Libraries for developing React JS Applications. These libraries helps us become more productive and develop high quality beautiful applications in less time.'
	}, {
	  title: 'Writing and Publishing a Simple Javascript Module to NPM',
	  url: 'https://v1.dhruvkumarjha.com/articles/writing-and-publishing-a-simple-javascript-module-to-npm',
	  date: '16th April 2017 at 04:30 PM',
	  excerpt: 'In this tutorial, We will first write a Javascript module which will act as a database/store for storing data which we can use in our other frontend applications. And then we will publish it to npm [node package manager].'
	}];
	
	exports.default = articles;
	module.exports = exports['default'];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _button = __webpack_require__(72);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(73);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _aside = __webpack_require__(120);
	
	var _aside2 = _interopRequireDefault(_aside);
	
	var _v = __webpack_require__(121);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelatedLinks = function RelatedLinks(props) {
	
	  if (props.data.type === 'post') {
	    return null;
	  }
	  if (!props.data.series) {
	    return null;
	  }
	
	  var aside = _aside2.default[props.data.series];
	  var asideData = void 0;
	
	  // depending on the type of aside content, store them in an arry for easier access.
	  if (aside && aside.type === 'sections') {
	    var arr = [];
	    aside.data.map(function (sections) {
	      sections.data.map(function (page) {
	        arr.push(page);
	      });
	    });
	    asideData = arr;
	  } else {
	    asideData = aside.data;
	  }
	
	  if (asideData.length < 1) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'related--series' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-container' },
	      _react2.default.createElement(
	        'p',
	        { className: 'title' },
	        'More in this series'
	      )
	    ),
	    asideData.map(function (post) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { key: post.url, to: post.url },
	        post.title
	      );
	    })
	  );
	};
	
	var ArticlesPage = function ArticlesPage(_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page--articles' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Some of the Articles and Tutorials on Frontend and Backend Development written by me.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Topics include Node JS, React, Express, GraphQL, MongoDB, Javascript, AI, PWA, Webpack, Business Analytics, Serverless and related.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/archive' },
	      _react2.default.createElement(
	        _button2.default,
	        { type: 'primary', style: { fontSize: 18 } },
	        'Looking for Older Tutorials or Website?'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'component--posts-list' },
	      data && data.allMarkdownRemark.edges.map(function (post) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'post', key: post.node.id },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.node.frontmatter.path },
	              post.node.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'published' },
	            post.node.frontmatter.date
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            post.node.excerpt
	          ),
	          _react2.default.createElement(RelatedLinks, { data: post.node.frontmatter })
	        );
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      { className: 'component--posts-list' },
	      _v2.default.map(function (link) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'post', key: link.url },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: link.url, target: '_blank' },
	              link.title
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'published' },
	            link.date
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            link.excerpt
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = ArticlesPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	/*
	

	**This website is powered by [Gatsby JS](https://www.gatsbyjs.org/) and [Firebase](https://firebase.google.com/)**

	      <Alert
	        message="Looking for Previous Version of Site?"
	        description={(<p><span>You can find all the previous articles <Link to="archive">Here (archive)</Link> and you can the website by <a href="https://v1.dhruvkumarjha.com" target="_blank">Clicking Here</a>.</span></p>)}
	        type="info"
	        showIcon
	        banner={true}
	        closable
	      />



	*/

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-articles-js-1bac303dfd19bad9f8f1.js